{
  "sources": ["painting-1538", "meischke-burgerweeshuis", "meischke-burgerweeshuis-huizen"],
  "note": "Four rented fronts before the earlier gasthuis are inferred from Meischke chapters 4 and 5 and the painted street row. Later numbers 94, 96, 98 and 100 identify their sequence, not surveyed 1538 boundaries. Widths, chainages, depths, parcel shear, low fronts, roof and gable types, access and rear-ground limits are fitted estimates. The 1553 rental register supports the sequence after 1538; the 1569–1578 rebuilds, 1581 gate and narrowing of 94, and later kitchens are not backdated.",
  "rows": [
    {
      "id": "sacraments-kalverstraat-fronts",
      "source": "street-kalverstraat",
      "side": "left",
      "to": 131,
      "depth": 19,
      "shear": -1.1,
      "evidence": "inferred",
      "houses": [
        {
          "id": "sacraments-kalverstraat-94-before-rebuilding",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "sacraments-kalverstraat-96-before-rebuilding",
          "widthWeight": 0.98,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "sacraments-kalverstraat-98-before-rebuilding",
          "widthWeight": 1.02,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "sacraments-kalverstraat-100-before-rebuilding",
          "widthWeight": 1.05,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        }
      ],
      "from": 154
    }
  ],
  "privateGround": [
    [-75.6, -303.7],
    [-120.5, -328],
    [-126, -352],
    [-113, -361],
    [-83, -333]
  ],
  "approach": [
    [-74.7, -304.6],
    [-104, -322.65]
  ],
  "noteApproach": "An estimated private access between the convent rentals and the Heilige Stede fronts remains open; it is not a named public street or the later monumental orphanage gate."
}
